type Props = {
  color?: string;
};

export default function TruckIcon({ color = '#000' }: Props) {
  return (
    <svg
      style={{ height: '56px', width: '56px' }}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="10" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0275 36H14.5C13.6716 36 13 35.3284 13 34.5V28.3705C13 27.8322 13.2884 27.3352 13.7558 27.0681L16.1831 25.6811C16.3913 25.5621 16.568 25.3949 16.6983 25.1936L21.5567 17.6851C21.8331 17.2579 22.3072 17 22.816 17H41.5C42.3284 17 43 17.6716 43 18.5V34.5C43 35.3284 42.3284 36 41.5 36H39.9725C39.7238 38.25 37.8163 40 35.5 40C33.1837 40 31.2762 38.25 31.0275 36H24.9725C24.7238 38.25 22.8163 40 20.5 40C18.1837 40 16.2762 38.25 16.0275 36ZM41 19V34H39.7439C39.1262 32.2522 37.4593 31 35.5 31C33.5407 31 31.8738 32.2522 31.2561 34H24.7439C24.1262 32.2522 22.4593 31 20.5 31C18.5407 31 16.8738 32.2522 16.2561 34H15V28.6606L17.1754 27.4176C17.3842 27.2983 17.5793 27.1582 17.7581 27H28V19H41ZM26 25V19H23.0881L19.2057 25H26ZM35.5 38C36.8807 38 38 36.8807 38 35.5C38 34.1193 36.8807 33 35.5 33C34.1193 33 33 34.1193 33 35.5C33 36.8807 34.1193 38 35.5 38ZM23 35.5C23 36.8807 21.8807 38 20.5 38C19.1193 38 18 36.8807 18 35.5C18 34.1193 19.1193 33 20.5 33C21.8807 33 23 34.1193 23 35.5Z"
        fill="#282A2C"
      />
    </svg>
  );
}
